import { Repeat } from '@/entities/rrule/constants';
import { fromUnixTime, getUnixTime } from 'date-fns';

export const useRRule = () => {
  const emptyWeekly = () => ({
    MO: true,
    TU: true,
    WE: true,
    TH: true,
    FR: true,
    SA: true,
    SU: true,
  });

  const emptyMonthly = () => ({
    day: Repeat.Day,
    setpos: 1,
  });

  const emptyRule = () => ({
    frequency: null,
    interval: 1,
    repeat: Repeat.Monthly,
    start: fromUnixTime(getUnixTime(new Date().setSeconds(0, 0))),
    monthly: emptyMonthly(),
    weekly: emptyWeekly(),
  });

  return {
    emptyWeekly,
    emptyRule,
    emptyMonthly,
  };
};
